module.exports = __webpack_public_path__ + "img/Croatia.71146b53.gif";